import React, { lazy, Suspense } from 'react';
import Loader from '../../../components/Loader/Loader.lazy';

const LazyAppVersions = lazy(() => import('./AppVersions'));

const AppVersionsHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyAppVersions {...props} />
  </Suspense>
);

export default AppVersionsHome;
